<script setup lang="ts">
import { Icon } from '@iconify/vue'
import './statistic-widget.scss'
import { numHelper } from '@/utils/numHelper.ts'

interface Props {
  title?: string // Tiêu đề widget
  description?: string // Chú thích ngắn phía dưới tiêu đề
  currentValue?: number // Giá trị hiện tại
  valueUnit?: string
  totalValue?: number // Giá trị tổng (nếu có)
  growthValue?: number // Giá trị tăng trưởng (có thể là phần trăm hoặc số tuyệt đối)
  growthValueUnit?: string
  growthDescription?: string // Chú thích cho giá trị tăng trưởng (vd: "so với tuần trước")
  icon?: string // Tên icon hoặc đường dẫn icon chính
  iconClass?: string // Class CSS tuỳ chỉnh cho icon chính (để styling)
  tip?: string // Tooltip hiển thị khi hover vào widget
}

const props = defineProps<Props>()

const emit = defineEmits(['@event:click'])

const handleClick = (e: MouseEvent) => {
  emit('@event:click', e)
  e.preventDefault()
}

</script>

<template>
  <div class="statistic-widget" @click="handleClick">
    <div class="statistic-widget__icon" v-if="props.icon">
      <icon :icon="props.icon"/>
    </div>
    <div class="statistic-widget__current">
      <div class="statistic-widget__current-value" v-if="props.currentValue">
        <div class="value">
          <span>{{numHelper(props.currentValue).format()}}</span>
          <span class="by_word" v-if="props.valueUnit === 'đ'">{{numHelper(props.currentValue).numberToVietnameseText()}} đồng</span>
        </div>
        <div class="unit" v-if="props.valueUnit">{{props.valueUnit}}</div>
      </div>
      <div class="statistic-widget__current-desc" v-if="props.title">{{props.title}}</div>
    </div>
    <div class="statistic-widget__growth">
      <div :class="`statistic-widget__growth-value ${ props.growthValue && props.growthValue < 0 ? 'down': ''}  ${ props.growthValue && props.growthValue > 0 ? 'up': ''}`" v-if="props.growthValue">
        <div class="flex flex-row items-start">
          <div class="value" v-if="props.growthValue && props.growthValue < 0">{{props.growthValue}}</div>
          <div class="value" v-if="props.growthValue && props.growthValue > 0">+{{props.growthValue}}</div>
          <div class="unit" v-if="props.growthValueUnit">{{props.growthValueUnit}}</div>
        </div>
        <div class="icon" v-if="props.growthValue && props.growthValue < 0">
              <Icon icon="ph:trend-down-bold" />
            </div>
        <div class="icon" v-if="props.growthValue && props.growthValue > 0">
              <Icon icon="ph:trend-up-bold" />
            </div>
      </div>
      <div class="statistic-widget__growth-desc" v-if="props.growthDescription">{{props.growthDescription}}</div>
    </div>
  </div>
</template>


<style scoped>

</style>
